const buttonFormservQuesList = {
  text: 'Adicionar Ação'
};

export default buttonFormservQuesList;
